import { render, staticRenderFns } from "./TableStoreClosedModal.vue?vue&type=template&id=2e46ba80"
import script from "./TableStoreClosedModal.vue?vue&type=script&lang=js"
export * from "./TableStoreClosedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports